import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/easyflex.webp';
import screenshot_target from '../../../images/letterfunnel/markremie.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Mark Remie"
      firstname="Mark"
      companyname="Easyflex"
      competition="Mysolution en Pivoton"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/markremie.js